import {
  PlayerBuilder,
  createComposablePlayer,
  createPlayerBuilder,
  createWebMafPlayerBuilder,
  createUVPPlayerBuilder,
  ExternalPlayer,
  PlaybackOptions,
  Manifest,
  Uint8ArrayUtils,
  StringUtils,
  BufferUtils,
  PlayerErrorCodes,
} from '@quickplay/player';
import { LicenceHandler } from './internal/LicenseHandler';
import { getLicenseHandler } from './internal/LicenseHandlerImpl';

const version = '__buildVersion__';

export {
  ExternalPlayer,
  PlaybackOptions,
  Manifest,
  PlayerBuilder,
  createComposablePlayer,
  version,
  createPlayerBuilder,
  createWebMafPlayerBuilder,
  createUVPPlayerBuilder,
  Uint8ArrayUtils,
  StringUtils,
  BufferUtils,
  LicenceHandler,
  getLicenseHandler,
  PlayerErrorCodes,
};
